import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import Passwordless from 'supertokens-web-js/recipe/passwordless';

export function initSupertokens(enableDebugLogs: boolean): void {
    console.log('Initializing supertokens');

    const backendURI = process.env.BASE_URLS.accountsReceivableApi ?? '';

    const topLevelDomain = `.${new URL(backendURI).hostname.split('.').slice(-2).join('.')}`;

    SuperTokens.init({
        enableDebugLogs,
        appInfo: {
            appName: 'Notch - App',
            apiDomain: backendURI,
            apiBasePath: '/auth',
        },
        recipeList: [
            Session.init({
                tokenTransferMethod: 'header',
                sessionTokenBackendDomain: topLevelDomain,
            }),
            EmailPassword.init(),
            Passwordless.init(),
        ],
    });
}
